import styled from "styled-components";

interface IStyledButtonProps  {
  fullWidth?: boolean;
}


export const StyledButton = styled.div<IStyledButtonProps>(({theme, fullWidth}) => `
  width: ${fullWidth ? '100%' : 'auto'};

  .MuiButton-contained,
  .MuiButton-outlined {
    font-family:  ${theme.uptimeFonts.primary}${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`} !important;
    padding: ${!!theme.uptimeFonts.primary ? (theme.uptimeDynamicAlignCenter?.button?.paddingTop ?? '6px') : `${theme.uptimeSpace[3]}px`} ${theme.uptimeSpace[8]}px;
    font-weight: bold;
    height: 40px;
    text-align: center;
    border-radius: ${theme?.uptimeBorderRadius?.button || 8}px;
    text-transform: ${theme.uptimeTextTransform.button ? theme.uptimeTextTransform.button === 'mixed' ? 'capitalize' : theme.uptimeTextTransform.button : 'initial'} !important;
    min-width: 125px;
    line-height: ${theme.uptimeLineHeights.desktop.lh2}px;

    & .MuiCircularProgress-root {
      color: ${theme.uptimeColors.generalColors.button.primary.text};
    }
  }

  .MuiButton-contained {
    background-color: ${theme.uptimeColors.generalColors.button?.primary?.enabled || theme.uptimeColors.mainTheme.secondary};
    color: ${theme.uptimeColors.generalColors.button?.primary?.text || theme.uptimeColors.grayScales.white};
    &:hover:enabled {
      background-color: ${theme.uptimeColors.generalColors.button?.primary?.hover || theme.uptimeColors.mainTheme.secondary};
      color: ${theme.uptimeColors.generalColors.button?.primary?.pressed || theme.uptimeColors.grayScales.white};
    }
  }

  .MuiButton-outlined {
    background-color: ${theme.uptimeColors.generalColors.button?.outline?.enabled || theme.uptimeColors.grayScales.white};
    color: ${theme.uptimeColors.generalColors.button?.outline?.text || theme.uptimeColors.mainTheme.secondary};
    border: 1px solid ${theme.uptimeColors.generalColors.button?.outline?.text || theme.uptimeColors.mainTheme.secondary} !important;

    &:hover {
      background-color: ${theme.uptimeColors.generalColors.button?.outline?.hover || theme.uptimeColors.mainTheme.secondary};
      color: ${theme.uptimeColors.generalColors.button?.outline?.pressed || theme.uptimeColors.grayScales.white};
      border-color: ${theme.uptimeColors.generalColors.button?.outline?.hover || theme.uptimeColors.mainTheme.secondary} !important;
    }
  }

  @media (max-width: 768px) {

    .MuiButton-contained,
    .MuiButton-outlined {
      width: 100%;
    }
  }
`);